package com.iregained.site.components.widgets.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val RegionSwitcherBannerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.backgroundColor(palette.nearBackground) // Subtle background color
            .color(palette.custom.darkText)
    }
}

val RegionSwitcherButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.backgroundColor(palette.brand.primary).color(Colors.White).padding(leftRight = 16.px, topBottom = 8.px)
            .borderRadius(4.px).fontWeight(FontWeight.Bold).fontSize(14.px)
            .textDecorationLine(com.varabyte.kobweb.compose.css.TextDecorationLine.None)
            .transition(Transition.of("background-color", 0.3.s))
    }
    hover {
        Modifier.backgroundColor(palette.brand.primary) // Darken on hover
    }
}

val RegionSwitcherCloseIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px).cursor(Cursor.Pointer).opacity(0.6f).transition(Transition.of("opacity", 0.3.s))
    }
    hover {
        Modifier.opacity(1f)
    }
}